



































import TrAddress from '@front-app/components/TrAddress.vue';
import { Association } from '@front-app/services/UserApi/UserModel';
import { isNonEmpty } from '@front-app/util/object';
import { defineComponent, PropType } from '@vue/composition-api';
import { EditableSection } from '../editableProfileSections';
import ProfileCard from '../ProfileCard.vue';

export default defineComponent({
	components: {
		ProfileCard,
		TrAddress,
	},
	props: {
		isCurrentUserProfile: Boolean,
		associations: {
			type: Array as PropType<Association[]>,
			required: true,
		},
	},
	setup() {
		return {
			EditableSection,
			isNonEmpty,
		};
	},
});
